import { ChangeDetectionStrategy, Component, inject, input, InputSignal } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'details-price',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './price.component.html',
  styleUrl: './price.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class DetailsPriceComponent {
    public translate = inject(TranslateService);
    public price: InputSignal<string> = input.required<string>();
    public fromBottomSheet: InputSignal<boolean> = input.required<boolean>();
}